import { AudioBusId, AudioBusVolumes } from './AudioBus';

export type AudioSettings = {
  masterVolume: number;
  busVolumes: AudioBusVolumes;
  /** HRTF spatializes via head-related transfer functions; equalpower is the cheap stereo pan. */
  hrtfEnabled: boolean;
  /** Global concurrent voice cap across the engine. Beyond this, oldest one-shot voices are stolen. */
  maxVoices: number;
};

export function defaultAudioSettings(): AudioSettings {
  return {
    masterVolume: 1.0,
    busVolumes: {
      music: 0.7,
      ambient: 0.7,
      sfx: 1.0,
      ui: 1.0,
      voice: 1.0,
    },
    hrtfEnabled: true,
    maxVoices: 64,
  };
}

export function clampVolume(v: number): number {
  if (!Number.isFinite(v)) return 0;
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

export function mergeAudioSettings(
  base: AudioSettings,
  patch: Partial<AudioSettings>,
): AudioSettings {
  return {
    masterVolume: patch.masterVolume ?? base.masterVolume,
    busVolumes: { ...base.busVolumes, ...(patch.busVolumes ?? {}) },
    hrtfEnabled: patch.hrtfEnabled ?? base.hrtfEnabled,
    maxVoices: patch.maxVoices ?? base.maxVoices,
  };
}

export function isBusId(id: string): id is AudioBusId {
  return id === 'music' || id === 'ambient' || id === 'sfx' || id === 'ui' || id === 'voice';
}
